import { type Context } from "@nuxt/types";

import { CREATOR_SITE_TERMS_OF_SERVICE } from "@/utils/constants";
import { FOUND } from "@/utils/enums/http-codes";

const middleware = ({ redirect, $config }: Context) => {
  return redirect(FOUND, `${$config.creatorSite}/${CREATOR_SITE_TERMS_OF_SERVICE}`);
};

export default middleware;
